import { render } from "./UltimosResultados.vue?vue&type=template&id=7f43e3b8&scoped=true"
import script from "./UltimosResultados.vue?vue&type=script&lang=js"
export * from "./UltimosResultados.vue?vue&type=script&lang=js"

import "./UltimosResultados.vue?vue&type=style&index=0&id=7f43e3b8&scoped=true&lang=css"
import "./UltimosResultados.vue?vue&type=style&index=1&id=7f43e3b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f43e3b8"]])

export default __exports__